export const ATTACHMENT_TYPE_SALE_DOCUMENT = 'saleDocument';
export const ATTACHMENT_TYPE_STORAGE_DOCUMENT = 'storageDocument';